import $ from 'jquery';
import './multistep-process';
import Swal from 'sweetalert2';
import intlTelInput from 'intl-tel-input';
// import * as bootstrap from 'bootstrap';

jQuery(function($){

    if( $('.kbcbooking.nc-customizer').length > 0 )
    {
        let form = document.querySelector('div.mstepform');
        try{
            window.kbcbook = new kbcBooking( form );
        }
        catch(e){
            console.log('kbcbooking error', e);
        }
        //end of booking form
    }
});

/**
 * replaceable values with classes when data populated
 * .cabin-price
 * .cabin-price-pp cabin price per person
 * .lowest-price-pp
 * .selected-group-type
 * .cruise-rental-pp
 * .selected-cruise-name
 * .selected-cruise-type
 * .cruise-rental 
 * .cabin-tax-percentage
 * img.cruise-layout-img //set img src
 * .tour-currency
 * .filter-group.pvt-hide //hide on private group
 * .filter-group.shared-hide //hide on shared group
 * .single-use-element // display or hide single use element
 * .single-use-percent
 * .single-use-tax
 * .reservation-total // 10% of final price
 * .guests-count
 */

class kbcBooking{

    opts = { minimumFractionDigits: 0 };

    constructor( form )
    {
        this.form = form;
        this.clickElement = null; //element user interacted

        //get tour data from backend
        this.kbcTourObj = kbcTourObj;
        // if this.kbcTourObj is empty trye to get data from ajaxurl
        if( this.kbcTourObj == undefined )
        {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Cruise data not found',
            }).then((result)=>{
                window.location.href = window.location.origin+'nckcruise';
            });
        }
        this.kbcTourObj.ajaxurl = ncf.ajaxurl;

        this.bookingData = {
            tourId: this.kbcTourObj.tourId,
            group   : '',
            periodKey : '',
            period  : '',
            cruise  : '',
            cruiseRentalPP: 0,
            cruiseRental: 0,
            cruiseName : '',
            cruiseType : '',
            cruiseLayout : '',
            finalPrice : 0,
            addonSum: 0,
            selectedCabins: [],
            cabinTax: 0,
            totalTaxPercent : 0,
            sharedCabinQty: 0, // not good to rely on this its only init after cabin tax calc
            sharedSingleUse: 0,
            costBreakdown: {}, // {item name: price}
            adminBooking: {},
            selCabinsCount: {},
            selCabinCosts: {}
        };

        // max guests allowed in boat
        this.maxGuests = 8;

        //cabin names
        this.defCabins = ['left-front', 'left-rear', 'right-front', 'right-rear'];

        this.disabledCabin = [];
        this.avaialbleCabins = [];
        
        this.underReservation = {};

        this.init();
    }

    init()
    {
        //bind form events
        this.bindEvents();

        //setup tour dynamic texts
        this.setTourDynamicText();

        //setup external libraries
        this.setupExternalLibs();
    }

    bindEvents()
    {
        //fade disabled fields
        this.fadeDisabledFields();

        //form next steps
        document.querySelectorAll('.form .next').forEach((ele)=>{
            ele.addEventListener('click', this.formSteps.bind(this));
        });

        //handle under reservation
        document.querySelectorAll('div.cruiseData button').forEach((ele)=>{
            ele.addEventListener('click', this.underReservationRequest.bind(this));
        });

        // under reservation form submit
        document.querySelector('form#tourSignupForm').addEventListener('submit', this.underReservationSubmit.bind(this));

        //update final price with addons select
        document.querySelectorAll('.addon-selector').forEach((ele)=>{
            ele.addEventListener('change', this.selectedAddonsPrice.bind(this));
        });

        // guest switcher
        document.querySelectorAll('.guests-switcher button').forEach((ele)=>{
            ele.addEventListener('click', this.guestsSwitcher.bind(this));
        });

        // single use checkboxes
        document.querySelectorAll('input.form-check-single-use').forEach((ele)=>{
            ele.addEventListener('change', this.sharedCabinSingleUse.bind(this));
        });

        //login form
        document.querySelector('div.form-login button.login-submit').addEventListener('click', this.handleLoginForm.bind(this));

        //register form
        document.querySelector('.form-register button.register-submit').addEventListener('click', this.handleRegisterForm.bind(this));

        //book for someone else
        let bookSomeone = document.querySelector('form#bookTourSomeoneForm');
        if( bookSomeone !== null )
            bookSomeone.addEventListener('submit', this.bookForSomeone.bind(this));

    }

    getName( key )
    {
        let names = {
            'pvt' : 'Private',
            'shared' : 'Shared',
        };
        if( names[key] == undefined )
            return '';

        return  names[key];
    }

    formSteps(e)
    {
        let view = e.target.getAttribute('sfid');
        if( view === null )
            return;

        this.clickElement =  e.target;

        let delay = 0;
        //remove all spinners from buttons
        document.querySelectorAll('button.next').forEach(function(ele)
        {
            if( ele.getAttribute('action') == 'previous' )
                ele.innerHTML = '<i class="fa fa-arrow-left" aria-hidden="true"></i> Previous Step';
            else if( ele.getAttribute('kbc') == 'selected' )
                ele.innerHTML = 'Selected';
            else 
            {
                let btnText = ele.dataset.text;
                if( btnText == undefined ) btnText = 'Select';
                if( !ele.classList.contains('disabled') ) 
                    ele.innerHTML = btnText;
            }
                
        });

        //check is clcked element button
        if( e.target.tagName == 'BUTTON' )
        {
            delay = 1000;

            let parentEle = e.target.parentElement.parentElement.parentElement.parentElement.parentElement;
            parentEle.querySelectorAll('.card').forEach(function(ele){
                ele.classList.remove('selected');
            });
            parentEle.querySelectorAll('button.next').forEach(function(ele){
                ele.removeAttribute('kbc');
            });

            e.target.parentElement.parentElement.parentElement.classList.add('selected');

            //add spinner
            let spinner = '<div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>';
            let text = 'Selected';
            if( e.target.getAttribute('action') == 'previous' )
                text = 'Previous Step';
            
            e.target.setAttribute('kbc', 'selected');
            e.target.innerHTML = text+' '+spinner;
        }

        if( document.querySelectorAll('fieldset[sfview="'+view+'"]').length > 0 )
        {
            this.processFormStepAction( e.target );

            //delay action
            setTimeout(function( ele=e.target, id=view  )
            {
                document.querySelectorAll('fieldset').forEach(function(ele){
                    ele.style.display = 'none';
                });
                document.querySelector('fieldset[sfview="'+id+'"]').style.display = 'block';
            }, delay);
            
        }

    }

    processFormStepAction( ele )
    {
        let selectorId = ele.getAttribute('sfid');
        let curView = document.querySelector('fieldset.active').getAttribute('sfview');
        
        switch( selectorId )
        {
            //fires on modification of group type actions
            case 'dgp':
                let groupType = ele.getAttribute(curView);
                
                //prevent calculation on previous button
                if( groupType == undefined || groupType == null )
                    break;

                //update booking data
                this.bookingData.group = groupType;
                this.bookingData.selCabinCosts = this.bookingData.selCabinCosts = {}; 

                //hide / show tour dates with group type
                this.filterTourDates();

                this.filterSummaryFaqs();
                
                this.bookingData.sharedCabinQty = 0;

                let groupPrice = 'pvtprice';
                if( this.bookingData.group == 'shared' )
                    groupPrice = 'sh-lowest-cabin';
                
                this.filterGroupWiseElements();

                //set lowest price on periods
                document.querySelectorAll('#dgppdates .accordion-item').forEach((sElem)=>{
                    let lowestPrice = [];
                    sElem.querySelectorAll('.cruiseData').forEach((lElem)=>{
                        let cruisePrice = lElem.getAttribute( groupPrice );

                        //set cruise prices
                        if( lElem.querySelector('.cabin-price') != null )
                            lElem.querySelector('.cabin-price').textContent = cruisePrice > 0 ? cruisePrice.toLocaleString(undefined, this.opts) : '-';

                        // calculate per person divider with group and cabin count
                        let divider = 2;
                        if( this.bookingData.group == 'pvt' )
                        {
                            let cabinCount = lElem.getAttribute('cabincount');
                            divider = 2 * parseInt(cabinCount);
                        }
                        let pricepp = cruisePrice > 0 ? Math.round( cruisePrice / divider ) : 0;
                        lowestPrice.push( pricepp );
                        lElem.querySelector('.cabin-price-pp').textContent = cruisePrice > 0 ? pricepp.toLocaleString(undefined, this.opts) : '-';
                    
                    });
                    //frind lowest number from array
                    let tprice = Math.min(...lowestPrice);
                    sElem.querySelector('.lowest-price-pp').textContent = tprice > 0 ? tprice.toLocaleString(undefined, this.opts) : '-';
                });

                //set name on summary
                document.querySelectorAll('.selected-group-type').forEach((ele)=>{
                    ele.textContent = this.getName(groupType);
                });

                break;
            
            //fires on modification of period N cruise actions
            case 'dgps':
                //update booking data
                //get tour key
                let periodEle = ele.closest('.tour-key');
                let tourKey = periodEle.getAttribute('tour-key');
                let cruise = ele.getAttribute('cruise-id');
                this.bookingData.periodKey = tourKey;
                this.bookingData.cruise = cruise;
                this.bookingData.cruiseLayout = this.kbcTourObj.cruiseData[cruise].layout;
                this.bookingData.selCabinsCount = this.bookingData.selCabinCosts = {}; 

                //update cruise layout images
                document.querySelectorAll('img.cruise-layout-img').forEach((ele)=>{
                    ele.setAttribute('src', this.bookingData.cruiseLayout);
                });

                //update cabins array and allowed guest count
                this._updateCabinLayout();

                //update period key
                if( periodEle.getAttribute('tour-period') != null )
                    document.querySelector('.selected-period').textContent = this.bookingData.period = periodEle.getAttribute('tour-period');

                //set cruise name and type
                let name = ele.parentElement.parentElement.querySelector('.cruise-name');
                document.querySelectorAll('.selected-cruise-name').forEach((ele)=>{
                    // remove more than one spaces
                    let cname = name.textContent.replace(/\s+/g, ' ');
                    ele.textContent = this.bookingData.cruiseName = cname;
                });
                document.querySelectorAll('.selected-cruise-type').forEach((ele)=>{
                    ele.textContent = this.bookingData.cruiseType = name.getAttribute('type');
                });

                // remove previously added options
                document.querySelectorAll('table.cost-breakdown tr[data-rec=features]').forEach((ele)=>{
                    ele.remove();
                });

                let periodData = this.kbcTourObj.tourPeriods[tourKey];

                //add cruise options to cost breakdown
                let totaltr = document.querySelector('table.cost-breakdown tr[data-rec=total]');
                let html,value = '';
                if( typeof periodData.cruises[cruise].features !== 'undefined' )
                {
                    Object.keys(periodData.cruises[cruise].features).forEach(key => {
                        value = this.kbcTourObj.cruiseData[cruise].features[key];
                        if( value.toLowerCase() == 'yes' ) value = '<i class="bx bx-check me-1"></i>';

                        if(value==false) return;
                        
                        html = `<tr data-rec="features">
                            <td class="flex-grow font-size-8 text-dark">${key}</td>
                            <td class="text-end font-size-8 text-dark">${value}</td>
                            </tr>`;

                        this.bookingData.costBreakdown[key] = value; 
                        totaltr.insertAdjacentHTML('beforebegin', html);
                    });
                }

                let yatchInfoSum = document.querySelector('.boat-features-sum .yatch-info');
                Object.keys(this.kbcTourObj.cruiseData[cruise].features).forEach(key => {
                    value = this.kbcTourObj.cruiseData[cruise].features[key];

                    if( value == false ) return;

                    html = `
                        <li class="px-5">
                            <span class="mb-1">
                                <i class="bx bx-check me-1"></i>
                                <span>${key}</span>
                            </span>
                            <span class="mb-1 float-end">
                                <span>${value}</span>
                            </span>
                        </li>
                    `;
                    yatchInfoSum.insertAdjacentHTML('beforeend', html);
                });
                
                //set cruise rental
                if( this.bookingData.group == 'shared' )
                    this.bookingData.cruiseRental = parseFloat(periodData.cruises[cruise].cabinprice);
                else
                    this.bookingData.cruiseRental = parseFloat(periodData.cruises[cruise].cb3baseprice);

                document.querySelectorAll('.cruise-rental').forEach((ele)=>{
                    ele.textContent = Math.round(this.bookingData.cruiseRental).toLocaleString(undefined, this.opts);
                });

                break;

            // confirmation payment - destination -> group -> period & boat -> summary -> checkout
            case 'dgpsc':
                //get checkout form html
                this.processCheckoutForm();
                break;

            case 'back':
                //history back
                window.history.back();
                break;

        }
        this.updateUrlWithBookingData();
    }

    _updateCabinLayout()
    {
        // check cruise cabin count
        let cabinCount = this.kbcTourObj.cruiseData[this.bookingData.cruise].cabinCount;
        let svgBoat = document.querySelector('#kbc-boat-svg');

        let svg = this.kbcTourObj.cruiseData[this.bookingData.cruise].svg;
        let layout = this.kbcTourObj.cruiseData[this.bookingData.cruise].layout;

        // clear selected cabins
        this.cruiseCabinSelector('all', true);

        // set cruise layout image
        document.querySelectorAll('img.cruise-layout-img').forEach((ele)=>{
            ele.setAttribute('src', layout);
        });

        let mptr = document.querySelectorAll('.cabin-mp5');
        document.querySelector('tr[data-rec=cabin-left-middle]').style.display = 'none';
        if( cabinCount == 5 )
        {
            this.defCabins = ['left-front', 'left-rear', 'left-middle', 'right-front', 'right-rear'];
 
            // display middle port on 5 cabins
            if( this.bookingData.group == 'shared' )
            {
                mptr.forEach((ele)=>{
                    ele.removeAttribute('style');
                });
            }
        }
        else 
        {
            this.defCabins = ['left-front', 'left-rear', 'right-front', 'right-rear'];

            // hide middle port on 4 cabins
            mptr.forEach((ele)=>{
                ele.style.display = 'none';
            });
            
        }

        // clear object data after new layout
        let clear = {
            availableCabins: [],
            addonSum: 0,
            costBreakdown: {},
            cruiseRental: 0,
            cruiseRentalPP: '-',
            finalPrice: 0,
            selCabinCosts: {},
            selCabinsCount: {},
            selectedCabins: [],
            sharedCabinQty: 0,
            totalTaxPercent: 0
        };
        Object.keys(clear).forEach(key => {
            this.bookingData[key] = clear[key];
        });

        // fetch svg boat layout and bind events
        fetch(svg)
            .then(resp => resp.text())
            .then(resp => {

            svgBoat.querySelector('svg').remove();
            svgBoat.insertAdjacentHTML('afterbegin', resp );

            this.defaultSelectedSvgCruiseCabins();

            //fix for text select
            this.defCabins.forEach((cabin)=>{
                let e = {target: document.querySelector('#'+cabin+'-cabin')};
                
                document.querySelector('#'+cabin+'-cabin-price').innerHTML = '';

                //continue if cabin disabled
                if( this.disabledCabin.includes(cabin) )
                    return;

                //cabin name
                document.querySelector('#'+cabin+'-cabin-price').addEventListener('click', ()=>{
                    this.cruiseCabinSelectOnClick(e);
                });
                
                //cabin status
                document.querySelector('#'+cabin+'-status-text').addEventListener('click', ()=>{
                    this.cruiseCabinSelectOnClick(e);
                });

                if( this.bookingData.group == 'pvt' )
                    return;

                let price = this.kbcTourObj.currencySymbol +''+ this.kbcTourObj.tourPeriods[ this.bookingData.periodKey ].cruises[ this.bookingData.cruise ][ 'sh-'+cabin ];

                //cabin price
                document.querySelector('#'+cabin+'-cabin-price').innerHTML = price;                
            });

            //svg cruise selector
            document.querySelectorAll('svg#kbc-cruise .cabin').forEach((ele)=>{
                ele.addEventListener('click', this.cruiseCabinSelectOnClick.bind(this));
            });
                
            this.updateFinalPrice();

        });

        // update max guest count
        this.maxGuests = this.defCabins * 2;

        // update boat gallery to summary gallery
        this._updateSummaryGallery();
    }

    _updateCabinPricePP()
    {
        if( !this.bookingData.selCabinsCount )
            return;

        let cabins = this.bookingData.selectedCabins.length;
        let persons = 0;

        if( !jQuery.isEmptyObject(this.bookingData.selCabinsCount) )
            persons = Object.values( this.bookingData.selCabinsCount ).reduce((a, b) => a + b);

        let price = this.bookingData.finalPrice;

        //update cruise or cabin rental pp
        if( price > 0 )
            this.bookingData.cruiseRentalPP = ( price / persons ).toFixed();
        else 
            this.bookingData.cruiseRentalPP = '-';
        
        //check count and price is numeric
        if( isNaN(this.bookingData.cruiseRentalPP) )
            this.bookingData.cruiseRentalPP = '-';
        
        document.querySelectorAll('.cruise-rental-pp').forEach((ele)=>{
            ele.textContent = this.bookingData.cruiseRentalPP.toLocaleString(undefined, this.opts);
        });
        document.querySelectorAll('.selected-cabins').forEach((ele)=>{
            ele.textContent = cabins;
        });
        document.querySelectorAll('.selected-persons').forEach((ele)=>{
            ele.textContent = persons;
        });
    }

    updateFinalPrice( value=0 )
    {
        if( this.clickElement.getAttribute('action')== 'previous' )
            return false;
     
        //set and calc cabin count and prices
        this._calcCabinCost();

        //update final  price
        let price = 0;
        if( this.bookingData.selectedCabins.length > 0 )
            price = parseFloat(this.bookingData.cruiseRental);

        //add shared cabin qty
        //disable checkout confirm button
        document.querySelector('button.next[sfid="dgpsc"]').removeAttribute('disabled');
        if( this.bookingData.selectedCabins.length == 0 )
            document.querySelector('button.next[sfid="dgpsc"]').setAttribute('disabled', 'disabled');
            
        //override with value
        if( value != 0 )
            price = parseFloat(value);

        //add addons price
        price += parseFloat(this.bookingData.addonSum) || 0;

        //add cruise tax
        price += parseFloat(this.bookingData.cabinTax) || 0;

        // round on 100 for private tour
        if( this.bookingData.group == 'pvt' )
            price = Math.round( price / 100 ) * 100;

        this.bookingData.finalPrice = price;

        document.querySelectorAll('.selected-final-price').forEach((ele)=>{
            let prefix = '',suffix = '';
            
            if( ele.getAttribute('prefix')!=null )
                prefix = ele.getAttribute('prefix');

            ele.textContent = prefix + price.toLocaleString(undefined, this.opts);
        });

        //update cabin price per person
        try{
            this._updateCabinPricePP();

            // set cost breakdown for private tour
            if( this.bookingData.group == 'pvt' )
            {
                let cabinName = '';
                this.bookingData.selectedCabins.forEach((cabin)=>{
                    cabinName += this.kbcTourObj.cabinNames[cabin][1]+',';
                });
                let key = 'Private_Boat_Tour_('+cabinName+')';
                this.bookingData.costBreakdown = Object.assign({ [key]: this.bookingData.finalPrice.toLocaleString(undefined, this.opts) }, this.bookingData.costBreakdown);
            }           
        }
        catch(e){
            console.log(e);
        }

        // update reservation total
        try{
            document.querySelectorAll('.reservation-total').forEach((ele)=>{
                ele.textContent = Math.round(price * 10 / 100).toLocaleString(undefined, this.opts);
            });
        }
        catch(e) { console.log(e); }
    }

    _calcCabinCost()
    {
        // calc cabin tax
        let tax = 0, taxPercentage = 0, totalTaxPercent = 0;
        if( this.bookingData.group == 'pvt' )
        {
            let count = this.bookingData.selectedCabins.length;
            let maxCabins = this.defCabins.length;
            this.bookingData.cruiseRental = this.kbcTourObj.tourPeriods[ this.bookingData.periodKey ].cruises[ this.bookingData.cruise ].cb3baseprice;
            if( count != maxCabins )
            {
                totalTaxPercent = this.kbcTourObj['pvtCabinRates'][ 'cb'+maxCabins ][ count ];
                totalTaxPercent =  totalTaxPercent - 100; // for have negative value
            }
            
            if( totalTaxPercent != '' && totalTaxPercent !== 0)
            {
                tax = parseFloat(this.bookingData.cruiseRental) * parseFloat(totalTaxPercent) / 100;
                tax = Math.round(tax/100) * 100;
            }

        }
        else {
            let cabins = this.bookingData.selectedCabins;
            this.bookingData.cruiseRental = 0;

            // loop selected cabins
            let cbnPos;
            cabins.map((cbn)=>{

                let cabinName = this.getCabinNameKey(cbn);

                // replace cabin prices
                let cbnPrice = parseInt( this.kbcTourObj.tourPeriods[ this.bookingData.periodKey ].cruises[ this.bookingData.cruise ][ 'sh-'+cbn ] );

                // check is 1 occupant then apply discount
                if( this.bookingData.selCabinsCount[cbn] == 1 )
                {
                    let discount = parseInt( this.kbcTourObj.tourPeriods[ this.bookingData.periodKey ].cruises[ this.bookingData.cruise ][ 'sh-'+cbn ] ) * parseInt( this.kbcTourObj.sharedSinglePercent ) / 100;
                    cbnPrice += discount;
                }

                document.querySelectorAll(`.cabin.${cbn}-price`).forEach((ele)=>{ 
                    ele.textContent = cbnPrice.toLocaleString(undefined, this.opts);
                });

                //set shared cruise rental
                this.bookingData.cruiseRental += cbnPrice;

                //set cost breakdown
                this.bookingData.costBreakdown = Object.assign({ [cabinName]: cbnPrice.toLocaleString(undefined, this.opts) }, this.bookingData.costBreakdown);
                    
            });
            //update cruise rental with selected cabins
            this.bookingData.sharedCabinQty = this.bookingData.selectedCabins.length || 0;
        }

        //update total tax percent
        this.bookingData.totalTaxPercent = totalTaxPercent;

        // update cabin tax on bookingData
        this.bookingData.cabinTax = tax;
        
        //update cain tax percentage
        document.querySelectorAll('.cabin-tax-percentage').forEach((ele)=>{
            ele.textContent = this.bookingData.totalTaxPercent || 0;
        });
    }

    selectedAddonsPrice(e)
    {
        let sum = 0;
        document.querySelectorAll('.addon-selector input[type="checkbox"]:checked').forEach(function(ele){
            sum += parseInt(ele.getAttribute('price'));
        });
        document.querySelector('.addon-sum').textContent = sum.toLocaleString(undefined, this.opts);
        this.bookingData.addonSum = sum;
        this.updateFinalPrice();
    }

    fadeDisabledFields()
    {
        document.querySelectorAll('.ele-disabled').forEach(function(ele){
            ele.style.pointerEvents = 'none';
            ele.style.opacity = '0.5';
        });
    }

    defaultSelectedSvgCruiseCabins()
    {
        let cruise = document.querySelector('svg#kbc-cruise');

        let eve = {
            target: null
        };
        if( this.bookingData.group != 'shared' )
        {
            // book all private cabins 
            this.cruiseCabinSelector('all', false);
            return;
        }
            
        eve.target = cruise.querySelector('.left-front.cabin');
        let cruiseD = this.kbcTourObj.tourPeriods[this.bookingData.periodKey].cruises[this.bookingData.cruise];
        
        // check periodData.bookedCabins exists
        if( cruiseD.bookedCabins !== undefined )
        {
            // disable booked cabins
            cruiseD.bookedCabins.map((cabin)=>{
                this.disableCruiseCabin(cabin);
            });
            // get avaialable cabin using defCabins and bookedCabins
            this.avaialbleCabins = this.defCabins.filter(x => !cruiseD.bookedCabins.includes(x));

            eve.target = cruise.querySelector('.'+this.avaialbleCabins[0]+'.cabin');
        }
            
    }

    disableCruiseCabin( cabin, disable=true )
    {
        if( cabin=='' ) return;

        //specific cabin
        let defc = this.defCabins.indexOf(cabin);
        if( defc == -1 ) throw new Error( cabin+' cabin not found to disable');
        
        // check cabin disabled
        let cabinEle = document.querySelector('#'+cabin+'-cabin');
        
        // cabim guest switcher
        let tr = document.querySelector('table.crew-member-selector tr[data-cabin='+cabin+']');

        let statusTxt = document.querySelector('#'+cabin+'-status-text');
        let cabinName = document.querySelector('#'+cabin+'-cabin-name');
        let cabinPrice = document.querySelector('#'+cabin+'-cabin-price');

        // check disable true 
        if( disable==true )
        {
            // disable cabin return
            cabinEle.classList.add('disabled');
            statusTxt.textContent = 'Booked';
            statusTxt.classList.add('disabled');
            statusTxt.classList.add('text-selected');

            cabinName.classList.add('disabled');
            cabinPrice.classList.add('disabled');

            if( !this.disabledCabin.includes(cabin) )
                this.disabledCabin.push(cabin);

            // disable cabin selector
            tr.querySelectorAll('button').forEach( btn =>{
                btn.disabled = true;
            });

            // setup guests count
            tr.querySelector('.cabin-people').textContent = 2;
            tr.style.display = 'none';

            return;
        }

        // remove disabled cabin status
        if( cabinEle.classList.contains('disabled') )
            cabinEle.classList.remove('disabled');

        if( cabinName.classList.contains('disabled') )
            cabinName.classList.remove('disabled');

        if( cabinPrice.classList.contains('disabled') )
            cabinPrice.classList.remove('disabled');

        if( statusTxt.classList.contains('disabled') )
            statusTxt.classList.remove('disabled');
            
        statusTxt.textContent = 'Available';
        statusTxt.classList.remove('text-selected');
        
        // remove cabin from disabledCabin
        if( this.disabledCabin.includes(cabin) )
        {
            let index = this.disabledCabin.indexOf(cabin);
            this.disabledCabin.splice(index);
        }
        // enable cabin selector
        tr.querySelectorAll('button').forEach( btn =>{
            btn.disabled = false;
        });
        // setup guests count
        tr.querySelector('.cabin-people').textContent = 0;
        tr.removeAttribute('style');

        return;
    }

    cruiseCabinSelectOnClick(e)
    {
        //user interacted cabin actions
        let cabinEle = e.target;
        let cabin = '', unselect = false;

        if(cabinEle==null) return;

        //get select or unselect status
        if( cabinEle.classList.contains('selected') )
            unselect = true;
            
        //get cabin name
        this.defCabins.map(function(cbn){
            if( cabinEle.classList.contains(cbn) )
                cabin = cbn;
        });

        this.cruiseCabinSelector(cabin, unselect);

        //calc cabin total
        // get tour group type
        if( this.bookingData.group == '' )
            return;

        this.bookingData.sharedCabinQty = 0;
        
        // update final price
        this.updateFinalPrice();
    }

    guestsSwitcher(e)
    {
        let parent = e.target.closest('.guests-switcher');
        let cabinTr = parent.closest('tr');
        let cabin = cabinTr.getAttribute('data-cabin');

        let button = e.target;
        if( button.tagName != 'BUTTON' )
            button = button.closest('button');

        let count = parseInt( parent.querySelector('.count').textContent );
        if( button.classList.contains('min') )
            count = 0;
        else
            count = 2;

        if( this.bookingData.group == 'shared' )
            this.bookingData.selCabinCosts[cabin] = this.kbcTourObj.tourPeriods[ this.bookingData.periodKey ].cruises[ this.bookingData.cruise ][ 'sh-'+cabin ];
        
        let unselect = false;
        if( count == 0 ) unselect = true;
            
        this.cruiseCabinSelector( cabin, unselect );

        this.updateFinalPrice();
                
        // replace frontend count
        cabinTr.querySelector('.cabin-people').textContent = count;
    }

    sharedCabinSingleUse(e)
    {
        let cabinTr = e.target.closest('tr');
        let cabin = cabinTr.getAttribute('data-cabin');
        let count = 1;
        
        if( !e.target.checked )
            count = 2;

        if( this.bookingData.group == 'shared' )
            this.bookingData.selCabinCosts[cabin] = this.kbcTourObj.tourPeriods[ this.bookingData.periodKey ].cruises[ this.bookingData.cruise ][ 'sh-'+cabin ];

        let unselect = false;
        this.cruiseCabinSelector( cabin, unselect );

        // update object count
        this.bookingData.selCabinsCount[cabin] = count;

        this.updateFinalPrice();
                
        // replace frontend count
        cabinTr.querySelector('.cabin-people').textContent = count;
    }

    /**
     * @param {*} cabin left-front, left-rear, right-front, right-rear, all
     * @param {} unselect
     */
    cruiseCabinSelector( cabin, unselect=false )
    {
        //cabin all actions
        if( cabin=='all' )
        {
            document.querySelectorAll('svg#kbc-cruise .cabin').forEach((ele)=>{
                this.defCabins.map((cabin)=>{
                    if( ele.classList.contains(cabin) )
                    {
                        //remove disabled cabins
                        this.disableCruiseCabin(cabin, false);

                        if(unselect==true)
                            this.cruiseCabinSelector(cabin, true);
                        else
                            this.cruiseCabinSelector(cabin);
                    }
                });
            });
            return;
        }
        
        //specific cabin
        let defc = this.defCabins.indexOf(cabin);
        if( defc == -1 ) return;
        
        //display cabin cost breakdown
        this.displayCabinCostBreakdown( cabin, unselect );

        // cabin selector
        let cabinTr = document.querySelector('table.crew-member-selector tr[data-cabin='+cabin+']');

        let cabinEle = document.querySelector('.'+cabin);
        let textEle = document.querySelector('#'+cabin+'-status-text');
        if( unselect==true )
        {
            cabinEle.classList.remove('selected');
            //change text
            textEle.classList.remove('text-selected');
            document.querySelector('#'+cabin+'-status-text').textContent = 'Available';
            
            //remove selected cabin cost count
            let index = this.bookingData.selectedCabins.indexOf(cabin);
            if( index !== -1 )
                this.bookingData.selectedCabins.splice(index, 1);

            // remove cabin count key
            //check cabin exists
            if( this.bookingData.selCabinsCount[cabin] !== undefined )
            {
                index = Object.keys(this.bookingData.selCabinsCount).indexOf(cabin);
                if( index !== -1 )
                    delete this.bookingData.selCabinsCount[cabin];
            }

            // update cabin poeple count
            cabinTr.querySelector('.cabin-people').textContent = 0;

            // uncheck the single use checkbox
            cabinTr.querySelector('input[name=single-'+cabin+']').checked = false;

            return;
        }

        cabinEle.classList.add('selected');
        //change text
        textEle.textContent = 'Selected';
        textEle.classList.add('text-selected');

        //update selected cabins
        if( !this.bookingData.selectedCabins.includes(cabin) )
            this.bookingData.selectedCabins.push(cabin);

        cabinTr.querySelector('.cabin-people').textContent = 2;
        this.bookingData.selCabinsCount[cabin] = 2;
    }

    displayCabinCostBreakdown( cabin, unselect )
    {
        if( this.bookingData.group=='pvt' )
            return;

        let element = document.querySelector('table.cost-breakdown tr[data-rec=cabin-'+cabin+']');

        //hide cabin cost breakdown
        if( unselect==true )
        {
            element.style.display = 'none';
            
            let cabinName = this.getCabinNameKey(cabin);

            //remove cost breakdown
            delete this.bookingData.costBreakdown[cabinName];
            return
        }

        //show cabin cost breakdown
        element.style.removeProperty('display');
    }

    /**
     * =====================================================================
     * 
     * @see filter tour dates and style boats section based on availability
     * 
     * =====================================================================
     */
    filterTourDates()
    {
        let group = this.bookingData.group;
        document.querySelectorAll('#dgppdates .accordion-item').forEach((ele)=>{

            let allDisabled = true;
            let availableCabins = [];
            /***
             * =====================================================================
             * boats dynamic status based on group 
             * eg: available for private tours | under reservation for shared tour 
             * =====================================================================
             */
            let cruises = ele.querySelectorAll('.cruiseData');
            cruises.forEach((cruise)=>{
                cruise.removeAttribute('style');
                
                let gstatus = cruise.dataset[group];
                let cruiseId = cruise.getAttribute('cruise-id');
                let btn = cruise.querySelector('button');

                // next step process
                let nextStep = {
                    sfid: 'dgps',
                };
                // remove all attributes
                while(btn.attributes.length > 0)
                    btn.removeAttribute(btn.attributes[0].name);

                btn.setAttribute('cruise-id', cruiseId);

                // boat status based on group type
                switch(gstatus){

                    case 'available':
                        btn.innerText = 'Book Now';
                        btn.setAttribute('data-btn-text', 'Book Now');
                        btn.setAttribute( 'sfid', nextStep.sfid );
                        btn.classList = 'btn btn-theme text-dark-grey d-block next next-step me-0';
                        allDisabled = false;
                        break;

                    case 'under_reservation':
                        btn.innerText = 'Join Waiting List';
                        btn.setAttribute('data-bs-toggle', 'modal');
                        btn.setAttribute('data-bs-target', '#reservationModal');
                        btn.setAttribute('data-btn-text', 'Join Waiting List');
                        btn.classList = 'btn btn-warning text-dark d-block under_reservation me-0';
                        allDisabled = false;
                        break;

                    case 'sold_out':
                        btn.innerText = 'Booked';
                        btn.setAttribute('disabled', 'disabled');
                        btn.setAttribute('data-btn-text', 'Booked');
                        btn.classList = 'btn btn-outline-secondary text-dark d-block sold_out me-0';
                        break;

                    case 'hidden':
                        cruise.style.display = 'none';
                        btn.innerText = 'Unavailable';
                        btn.classList = 'btn btn-outline-secondary text-dark d-block disabled me-0';
                        btn.setAttribute('disabled', 'disabled');
                        break;

                    default:
                        btn.innerText = 'Unavailable';
                        btn.classList = 'btn btn-outline-secondary text-dark d-block disabled me-0';
                        btn.setAttribute('disabled', 'disabled');
                        break;

                }

                //mark available cabins
                let bookedCabins = cruise.getAttribute('booked-cabins');
                let cabinCount = parseInt( cruise.getAttribute('cabinCount') );
                let availableCabinCount = cabinCount;
                if( bookedCabins !== '' && bookedCabins !== null )
                {
                    bookedCabins = bookedCabins.split(',').length;
                    availableCabinCount = cabinCount - parseInt(bookedCabins);
                }
                else bookedCabins = 0;

                cruise.querySelector('.available-cabins').textContent = ( availableCabinCount > 0 && gstatus != 'sold_out' ) ? availableCabinCount : 'No';
                if( bookedCabins < cabinCount )
                    availableCabins.push(cruise.getAttribute('cruise-id'));

            });

            //setup group status and text
            let status = ele.getAttribute('tour-status');
            let tourKey = ele.querySelector('.accordion-header button.accordion-button').getAttribute('tour-key');
            if( allDisabled )
                status = 'sold_out';

            if( status=='available' && availableCabins.length==0 )
                status = 'sold_out';

            /**
             * ===========================================================================
             * @see if all boats sold out mark the period as sold out on accordion header
             * ===========================================================================
             */
            this.changeTourPeriodStatus( tourKey, status );

        });

        //display no avaialble tours for this year message
        document.querySelectorAll('#dgppdates .tab-pane').forEach((ele)=>{
            let accordions = [];
            Array.from(ele.children).forEach((accordion)=>{
                if( accordion.style.display == 'none' )
                    accordions.push(false);
                else 
                    accordions.push(true);
            });

            //find if all are hidden
            if( accordions.indexOf(true) == -1 )
            {
                let msg = document.createElement('div');
                msg.classList.add('alert', 'alert-warning');
                msg.textContent = 'No cruises available yet for this year';
                ele.appendChild(msg);
            }
            else {
                if( ele.querySelector('.alert') != null )
                    ele.querySelector('.alert').remove();
            }
        });

        //check if there's no tours display then show empty message
        if( document.querySelector('#dgppdates .tab-content').children.length==0 )
        {
            let msg = document.createElement('div');
            msg.classList.add('alert', 'alert-warning');
            msg.textContent = 'No Cruises available yet';
            document.querySelector('#dgppdates .tab-content').appendChild(msg);
        }
    }

    changeTourPeriodStatus( tourKey, status )
    {
        let element = null;
        document.querySelectorAll('fieldset[sfview=dgp] .accordion-header button.accordion-button').forEach((ele)=>{

            if( ele.getAttribute('tour-key')==tourKey )
            {
                element = ele.parentElement.parentElement;
                return;   
            }
                
        });
        
        if( element == null )
            throw new Error( tourKey+' Element not found');

        // set group status
        let header = element.querySelector('.accordion-header');
        let abody = element.querySelector('.accordion-body');
        
        let count = 0;
        //get all childrens and count
        let boats = abody.querySelector('.assigned-cruise').children;
        if( boats !== null )
        {
            this._sortBoatsByPrice( boats );

            //count available boats
            count = Array.from(boats).filter((boat) => {
                return boat.querySelector('.cruiseData').style.display !== 'none';
            }).length;
        }

        switch( status ) 
        {
            case 'booked':
                //title
                header.querySelector('p.period').classList.remove('text-dark-grey');
                header.querySelector('p.period').classList.add('text-grey-darker');
                //price
                header.querySelector('p.price').classList.remove('text-secondary');
                header.querySelector('p.price').classList.add('text-grey-darker');
                //badge
                header.querySelector('.status.badge').classList.remove(...['bg-theme', 'text-dark']);
                header.querySelector('.status.badge').classList.add(...['bg-grey-darker', 'text-light']);
                header.querySelector('.status.badge').textContent = 'Booked';
                
                //set as no catamaran available
                abody.querySelector('.available-cruise').textContent = 'No Boats Available';
                //hide all boats
                abody.querySelectorAll('.assigned-cruise').forEach((ele)=>{
                    ele.style.display = 'none';
                });
                break;

            case 'available':
                //title
                header.querySelector('p.period').classList.remove('text-grey-darker');
                header.querySelector('p.period').classList.add('text-dark-grey');
                //price
                header.querySelector('p.price').classList.remove('text-grey-darker');
                header.querySelector('p.price').classList.add('text-secondary');
                //badge
                header.querySelector('.status.badge').classList.remove(...['bg-grey-darker', 'bg-danger-light', 'text-dark']);
                header.querySelector('.status.badge').classList.add(...['bg-theme', 'text-light']);
                header.querySelector('.status.badge').textContent = 'Available';

                //display all boats
                abody.querySelectorAll('.assigned-cruise').forEach((ele)=>{
                    //remove display block
                    ele.removeAttribute('style');
                });
                //set as catamaran available
                abody.querySelector('.available-cruise').textContent = count+' Boats Available';
                break;

            case 'sold_out':
                //title
                header.querySelector('p.period').classList.remove(...['text-dark-grey', 'text-secondary']);
                header.querySelector('p.period').classList.add('text-grey-darker');
                //price
                header.querySelector('p.price').classList.remove(...['text-dark-grey', 'text-secondary']);
                header.querySelector('p.price').classList.add('text-grey-darker');
                //badge
                header.querySelector('.status.badge').classList.remove(...['bg-theme', 'bg-warning', 'text-dark']);
                header.querySelector('.status.badge').classList.add(...['bg-danger-light', 'text-light']);
                header.querySelector('.status.badge').textContent = 'Sold Out';
                //set as catamaran not available
                abody.querySelector('.available-cruise').textContent = 'No Boats Available';
                break;

            case 'under_reservation':
                //title
                header.querySelector('p.period').classList.remove('text-dark-grey');
                header.querySelector('p.period').classList.add('text-grey-darker');
                //price
                header.querySelector('p.price').classList.remove('text-secondary');
                header.querySelector('p.price').classList.add('text-grey-darker');
                //badge
                header.querySelector('.status.badge').classList.remove(...['bg-theme', 'bg-danger-light', 'text-light']);
                header.querySelector('.status.badge').classList.add(...['bg-warning', 'text-dark']);
                header.querySelector('.status.badge').textContent = 'Under Reservation';
                break;

            case 'not_available':
                //title
                header.querySelector('p.period').classList.remove('text-dark-grey');
                header.querySelector('p.period').classList.add('text-grey-darker');
                //price
                header.querySelector('p.price').classList.remove('text-secondary');
                header.querySelector('p.price').classList.add('text-grey-darker');
                //set as no catamaran available
                abody.querySelector('.available-cruise').textContent = 'No Boats Available';
                //badge
                header.querySelector('.status.badge').classList.remove('bg-theme');
                header.querySelector('.status.badge').classList.add('bg-grey-darker');
                header.querySelector('.status.badge').textContent = 'Not Available';
                break;

        }
    }

    _sortBoatsByPrice( boats )
    {
        let sorted = [];
        let key = 'sh-lowest-cabin';
        //sort boats by lowest price
        if( this.bookingData.group == 'pvt' ) key = 'pvtprice';

        sorted = Array.from(boats).sort((a,b)=>{
            return a.querySelector('.cruiseData').getAttribute('sh-lowest-cabin') - b.querySelector('.cruiseData').getAttribute('sh-lowest-cabin');
        });

        // add order-list class to sort by lowest price
        sorted.forEach((boat)=>{
            //remove any order-* classes
            boat.classList.remove(...['order-1', 'order-2', 'order-3', 'order-4', 'order-5', 'order-6', 'order-7', 'order-8', 'order-9', 'order-10']);
            boat.classList.add('order-'+ ( sorted.indexOf(boat)+1 ) );
        });
    }

    setTourDynamicText()
    {
        //replace tour currency
        document.querySelectorAll('.tour-currency').forEach((ele)=>{
            ele.innerHTML = this.kbcTourObj.currencySymbol;
        });
    }

    processCheckoutForm()
    {
        let ajaxurl = this.kbcTourObj.ajaxurl+'?action=kbc_checkout_form';
        this.ajaxCall( ajaxurl, this.bookingData ).then((response)=>{
            if( response.status == true )
                window.location.href = window.location.href+'?kbc_checkout=true';
            else {
                let title = 'Something went wrong';
                if( response.action != null && response.action == 'login_register' )
                {
                    document.querySelector('.login-register').classList.remove('d-none');
                    document.querySelector('.checkout-loading').classList.add('d-none');
                    document.querySelector('fieldset[sfview="dgpsc"] h3.title').textContent = 'Login or Register';
                    return;
                }
                
                document.querySelector('.login-register').classList.add('d-none');
                document.querySelector('.checkout-loading').classList.remove('d-none');
                document.querySelector('fieldset[sfview="dgpsc"] h3.title').textContent ='Processing your booking';

                Swal.fire({
                    title: title,
                    text: response.error,
                    icon: 'error',
                });
            }
        });
    }

    async ajaxCall( url, data )
    {
        //stringify any json found inside data json
        for ( const [key, value] of Object.entries(data) )
        {
            if (typeof value === 'object' && !Array.isArray(value) ) {
                data[key] = JSON.stringify(value);
            }
        }

        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        let response = await fetch(url, {
            method: 'POST',
            body: formData
        });

        return response.json();
    }

    updateUrlWithBookingData()
    {
        let data = this.bookingData;

        let url = window.location.href.split('?')[0];
        let query = '';
        // for( let key in data )
        // {
        //     query += key+'='+data[key]+'&';
        // }
        // query = query.slice(0, -1);

        // query = 'kbc_checkout=true';
        // window.history.pushState({}, '', url+'?'+query);
    }

    handleLoginForm(e)
    {
        e.preventDefault();
        let formDiv = document.querySelector('.form-login');
        let data = {
            action: 'kbc_login_form',
            username: formDiv.querySelector('input[name="email"]').value,
            password: formDiv.querySelector('input[name="password"]').value,
            remember: formDiv.querySelector('input[name="remember"]').checked
        };
        //validate form
        if( data.email == '' || data.password == '' )
        {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Email and password required',
            });
            return;
        }

        //add spinner
        let spinner = '<div class="spinner-border spinner-border-sm me-2" role="status"><span class="visually-hidden">Loading...</span></div>';
        e.target.insertAdjacentHTML( 'afterbegin', spinner );

        //login ajax call
        this.ajaxCall( this.kbcTourObj.ajaxurl+'?action=kbc_login_form', data ).then((response)=>{
            if( response.status == true )
            {
                Swal.fire({
                    icon: 'success',
                    title: 'Login Success',
                    text: response.message,
                }).then((result)=>{
                    //clear fileds
                    formDiv.querySelector('input[name="email"]').value = '';
                    formDiv.querySelector('input[name="password"]').value = '';

                    // processing booking
                    document.querySelector('.login-register').classList.add('d-none');
                    document.querySelector('.checkout-loading').classList.remove('d-none');
                    document.querySelector('fieldset[sfview="dgpsc"] h3.title').textContent ='Processing your booking';

                    // process checkout
                    this.processCheckoutForm();
                });
            }
            else {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: response.error,
                });
            }
            //remove spinner-border
            formDiv.querySelector('.spinner-border').remove();
        });

    }

    handleRegisterForm(e)
    {
        e.preventDefault();
        let formDiv = document.querySelector('.form-register');
        let data = {
            action: 'kbc_register_form',
            email: formDiv.querySelector('input[name=email]').value,
            password: formDiv.querySelector('input[name=password]').value,
            firstname: formDiv.querySelector('input[name=firstname]').value,
            lastname: formDiv.querySelector('input[name=lastname]').value,
        };

        //validate form
        if( data.email == '' || data.password == '' || data.firstname == '' || data.lastname == '' )
        {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'All fields required',
            });
            return;
        }

        //login ajax call
        this.ajaxCall( this.kbcTourObj.ajaxurl+'?action=kbc_register_form', data ).then((response)=>{
            if( response.status == true )
            {
                Swal.fire({
                    icon: 'success',
                    title: 'Register Success',
                    text: response.message,
                }).then((result)=>{
                    //clear fileds
                    formDiv.querySelector('input[name=firstname]').value = '';
                    formDiv.querySelector('input[name=lastname]').value = '';
                    formDiv.querySelector('input[name=email]').value = '';
                    formDiv.querySelector('input[name=password]').value = '';

                    // processing booking
                    document.querySelector('.login-register').classList.add('d-none');
                    document.querySelector('.checkout-loading').classList.remove('d-none');
                    document.querySelector('fieldset[sfview="dgpsc"] h3.title').textContent ='Processing your booking';

                    // process checkout
                    this.processCheckoutForm();
                });
            }
            else {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: response.error,
                });
            }
        });
    }

    filterSummaryFaqs()
    {
        document.querySelectorAll('#summaryfaq .accordion-item').forEach((ele)=>{
            ele.style.display = 'none';
            if( this.bookingData.group == 'pvt' )
            {
                if( ele.classList.contains('faq_pvt') )
                    ele.style.display = 'block';   

                return;
            }

            if( ele.classList.contains('faq_shared') )
                ele.style.display = 'block';
        });
    }

    underReservationRequest(e)
    {
        if( e.target.tagName != 'BUTTON' || !e.target.classList.contains('under_reservation') )
            return;
            
        let periodKey = e.target.closest('.tour-key').getAttribute('tour-key');
        let cruiseId = e.target.closest('.cruiseData').getAttribute('cruise-id');
        this.underReservation.data = {
            tourId: this.bookingData.tourId,
            group: this.bookingData.group,
            periodKey: periodKey,
            cruiseId: cruiseId
        };
    }

    underReservationSubmit(e)
    {
        e.preventDefault();
        let modal = e.target.closest('.modal');

        let data = this.underReservation.data;
        if( data == undefined )
        {
            Swal.fire({
                title: 'Oops! Soemthing went wrong',
                text: 'cruise data not found',
                icon: 'error',
            });
            return false;
        }

        //submit reservation data
        data.action = 'under_reservation_request';

        //add form data to data
        let form = document.querySelector('form#tourSignupForm');
        data.fname = form.querySelector('input[name=firstName]').value;
        data.lname = form.querySelector('input[name=lastName]').value;
        data.email = form.querySelector('input[name=email]').value;
        data.phone = form.querySelector('input[name=phone_full]').value;
        data.countrycode = form.querySelector('input[name=country_code]').value;
        data.signupfor = form.querySelector('select[name=signUpFor]').value;
        data.contactmethod = form.querySelector('select[name=contactMethod]').value;
        data.comments = form.querySelector('textarea[name=comments]').value;
        data.marketingPermission = form.querySelector('input[name=marketingPermission]').checked;

        if( data.phone == '' ) data.phone = form.querySelector('input[name=phone]').value;

        //add spinner to button
        e.target.querySelector('button[type=submit]').disabled = true;

        //ajax call
        this.ajaxCall( this.kbcTourObj.ajaxurl, data ).then((resp)=>{
            e.target.querySelector('button[type=submit]').disabled = false;
            if( resp.success == false )
            {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: resp.data,
                }).then((result)=>{
                    //close all bootstrap modals
                    document.querySelectorAll('#reservationModal').classList.remove('show');
                });
                return;
            }
            Swal.fire( resp.data, '', 'success');
            // close modal
            modal.classList.remove('show');
            modal.style.display = 'none';
            document.querySelector('.modal-backdrop').remove();
        }).catch(error => {
            Swal.showValidationMessage(
                `Request failed: ${resp.data}`
            );
        });
        
    }

    filterGroupWiseElements()
    {
        document.querySelectorAll( '.filter-group' ).forEach((ele)=>{
            //remove display style
            ele.style.removeProperty('display');
            
            if( ele.classList.contains( this.bookingData.group+'-hide' ) )
                ele.style.display = 'none';
        });
    }

    setupExternalLibs()
    {
        //intl-tel-input
        let input = document.querySelector("#tourSignupForm input#phone");
        if( typeof input != 'undefined' && input != null  ) 
        {
            try{
                intlTelInput(input, {
                    utilsScript: "build/js/utils.js",
                    hiddenInput: function(telInputName) {
                        return {
                            phone: "phone_full",
                            country: "country_code"
                        };
                    }
                });
            }
            catch(e) { console.log(e); }
        }

    }

    getCabinNameKey(cabin)
    {
        let cabinName = this.kbcTourObj.cabinNames[cabin][0];
        //replace spaces with _
        return cabinName.replace(/\s/g, '_');
    }

    bookForSomeone(e)
    {
        e.preventDefault();
        e.target.querySelector('button[type=submit]').disabled = true;

        // add booking user details
        this.bookingData.adminBooking = {};
        this.bookingData.adminBooking.firstName = e.target.querySelector('input[name=firstname]').value;
        this.bookingData.adminBooking.lastName = e.target.querySelector('input[name=lastname]').value;
        this.bookingData.adminBooking.email = e.target.querySelector('input[name=email]').value;
        this.bookingData.adminBooking.phone = e.target.querySelector('input[name=phone]').value;
        this.bookingData.adminBooking.reserv = e.target.querySelector('input[name=reservPeriod]').value;

        let ajaxurl = this.kbcTourObj.ajaxurl+'?action=kbc_admin_checkout';
        this.ajaxCall( ajaxurl, this.bookingData ).then((resp)=>{
            e.target.querySelector('button[type=submit]').disabled = false;

            // on success
            if( resp.status )
            {
                // close modal
                e.target.closest('.modal').classList.remove('show');
                e.target.closest('.modal').style.display = 'none';
                document.querySelector('.modal-backdrop').remove();
                
                // title
                resp.title = 'Booking reserved for '+resp.reservPeriod;

                let clipboard = `username:`+resp.login+'\n'+
                    `password:`+resp.password+'\n'+
                    `checkout url:`+resp.checkoutUrl;

                // checkout url for clipboard copy
                resp.html = `
                <div class="table-responsive">
                    <table class="table">
                        <tr>
                            <td class="mb-1 miw-100 text-secondary"><strong>Username:</strong></td>
                            <td class="mb-1">`+resp.login+`</td>
                        </tr>
                        <tr>
                            <td class="mb-1 miw-100 text-secondary"><strong>Password:</strong></td>
                            <td class="mb-1">`+resp.password+`</td>
                        </tr>
                        <tr>
                            <td class="miw-100 text-secondary"><strong>Checkout URL:</strong></td>
                            <td>`+resp.checkoutUrl+`</td>
                        </tr>
                    </table>
                    <button class="btn btn-sm btn-info copytoclipboard" data-clipboard="`+clipboard+`">Copy to Clipboard</button>
                </div>`;
            }
            else {
                resp.title = 'Something went wrong';
                resp.html = '<p>'+resp.error+'</p>';
            }
                
            Swal.fire({
                title: resp.title,
                html: resp.html,
                showCloseButton: true,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false
            })
            .then((result)=>{
                if( resp.status ) window.location.reload();
            })

            // disable checkout button
            document.querySelector('button[sfid=dgpsc]').disabled = true;

            let clipboard = document.querySelector('.copytoclipboard');
            if( clipboard != null )
            {
                clipboard.addEventListener('click', function(e){
                    e.preventDefault();
                    let clipboard = e.target.getAttribute('data-clipboard');
                    navigator.clipboard.writeText(clipboard);
                });
            }
        });

    }

    _updateSummaryGallery()
    {
        // get selected boat gallery
        let gallery = this.kbcTourObj.cruiseData[this.bookingData.cruise].cruise_gallery;

        // clear gallery
        let carouselTour = document.querySelector('#carouselTour');
        let indicators = carouselTour.querySelector('.carousel-indicators');
        indicators.innerHTML = '';

        let inner = carouselTour.querySelector('.carousel-inner');
        inner.innerHTML = '';

        if( typeof gallery == 'undefined' )
            return;

        // replace items
        gallery.forEach((item, index)=>{

            let nextIndex = index+1;
            indicators.insertAdjacentHTML(
                'beforeend',
                `<button type="button" data-bs-target="#carouselTour" data-bs-slide-to="${index}" class="`+( index==0 ? 'active' : '' )
                +`" aria-current="true" aria-label="Slide ${nextIndex}"></button>`
            );

            inner.insertAdjacentHTML(
                'beforeend', 
                `<div class="carousel-item`+ (index == 0 ? ' active' : '' ) +`">
                    <img class="width-p-100 mxh-400 object-fit-cover rounded" src="${item}" alt="">
                </div>`
            );

        });

    }

    //end of class
}